var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loyalty-program-page"}},[_c('LandingBannner'),_c('ExtraInfo'),_c('LoyaltyLevel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }